import useSWR, { SWRResponse } from "swr";
import { BadResponseBodyError } from "../bad-response-body-error";
import { HttpError } from "../http-error";
import { UserResponse } from "./user";
import { parse } from "cookie";

const getLoggedOutCookie = (cookies: string) => {
  const cookie = parse(cookies || "");
  if (cookie["loggedOut"]) {
    return parseInt(cookie["loggedOut"]);
  }
  return 1;
};

async function userFetcher(url: string): Promise<UserResponse> {
  const isLoggedOut = getLoggedOutCookie(document.cookie);
  if (isLoggedOut === 1) {
    return { user: null };
  }

  const res = await fetch(url);
  if (res.status === 401) {
    throw new HttpError(401, "Not authorized!");
  }

  return BadResponseBodyError.throwIfLeft(res.status,
    UserResponse.decode(await res.json()));
}

export function useUserSWR(): SWRResponse<UserResponse, HttpError> {
  return useSWR(
    "/api/user",
    userFetcher
  );
}